import { Badge } from '@chakra-ui/react';

export const ArchivedBadge = (props: { archived?: boolean }) => {
  if (!props.archived) {
    return null;
  }

  return (
    <Badge size="sm" colorScheme="gray" variant="outline">
      Archived
    </Badge>
  );
};
